export const FailedToLoadPage = 'An error occurred while loading the page. Please try again.';
export const TooLong = (max: number): string => `Must be less than ${max} characters.`;
export const Numeric = 'Must be numeric.';
export const InvalidDomainName = 'Invalid format.';
export const FailedToSaveAccount = 'An error occurred while saving this account.';
export const RemoveWWW = 'Remove "www."';
export const ErrorLoadingClaimInformation = 'An error occurred while loading claim information.';
export const ErrorLoadingKPI = 'An error occurred while loading key performance indicators.';
export const FieldRequired = 'This field is required';
export const MMDDYYYY = 'Must be mm/dd/yyyy';
export const CoverageTypeMissingInWorksheet = 'Coverage Type is missing in cell B8.';
export const XLSXNumberErrorMessage = 'Expected a number for ${label}';
export const XLSXOldVersionErrorMessage = 'It appears you are using the old version of the tower template, please re-upload data using a template provided below.';
// The API words its 404 and 409 messages for people (e.g. why a 409 was refused). Other statuses
// carry a status text or a raw validator dump, so callers fall back to their own wording.
const PEOPLE_WORDED_STATUSES = [404, 409];

export function clientErrorMessage(error: unknown): string | undefined {
  const status = (error as { cause?: { status?: number } })?.cause?.status;
  return error instanceof Error && status !== undefined && PEOPLE_WORDED_STATUSES.includes(status) ? error.message : undefined;
}
